export enum ApiResult {
  ERROR_CREATE_CONTRACT = 'ERROR_CREATE_CONTRACT',
  ERROR_UPDATE_CONTRACT = 'ERROR_UPDATE_CONTRACT',
  ERROR_CREATE_DELIVERY = 'ERROR_CREATE_DELIVERY',
  ERROR_UPDATE_DELIVERY = 'ERROR_UPDATE_DELIVERY',
  ERROR_CREATE_DELIVERY_ALREADY_EXIST = 'ERROR_CREATE_DELIVERY_ALREADY_EXIST',
  ERROR_EXPORT = "ERROR_EXPORT",
  ERROR_CREATE_DELIVERYSECTION = 'ERROR_CREATE_DELIVERYSECTION',
  ERROR_UPDATE_DELIVERYSECTION = 'ERROR_CREATE_DELIVERYSECTION',
  INFO_SELECTION_NULL = "INFO_SELECTION_NULL",
  ERROR_CREATE_DELIVERYSECTION_ALREADY_EXIST = 'ERROR_CREATE_DELIVERYSECTION_ALREADY_EXIST',
}
